import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import RawmaterialEditForm from './RawmaterialEditForm';
import RawmaterialList from './RawmaterialList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import RawmaterialListView from './RawmaterialListView'


export default function RawmaterialDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.rawmaterialDashboard);
  const [ rawmaterialId, setRawmaterialId] = React.useState('');
  const [reloadRawmaterialList, setReloadRawmaterialList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <RawmaterialEditForm 
            setReloadRawmaterialList={setReloadRawmaterialList}
            rawmaterialId={rawmaterialId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <RawmaterialListView 
                      setRawmaterialId = {setRawmaterialId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
